
import React from "react";
import { DataTable } from "@/components/shared/DataTable";
import { variantMeasurementColumns } from "./VariantMeasurementColumns";
import { VariantMeasurement } from "@/hooks/useVariantMeasurements";

interface VariantMeasurementListProps {
  measurements: VariantMeasurement[];
  isLoading: boolean;
  onAdd: () => void;
  onEdit: (measurement: VariantMeasurement) => void;
  onDelete: (measurement: VariantMeasurement) => Promise<boolean>;
}

export function VariantMeasurementList({
  measurements,
  isLoading,
  onAdd,
  onEdit,
  onDelete
}: VariantMeasurementListProps) {
  return (
    <DataTable
      data={measurements}
      columns={variantMeasurementColumns}
      onEdit={onEdit}
      onDelete={onDelete}
      onAdd={onAdd}
      title="Variant Measurements"
      itemName="Measurement"
      isLoading={isLoading}
      searchColumn="part_name"
    />
  );
}
